import React from 'react';

const UploadField = (props) => {
    const { value, onChange, name, error, className, labelText } = props;
    const hasError = !!error;

    const truncate = (source, size) =>
        source?.length > size ? source.slice(0, size - 1) + '…' : source;

    const wrapperClass =
        'relative' +
        (hasError ? ' error' : '') +
        (className ? ' ' + className : '');

    const boxClass =
        '!relative w-full px-4 py-4 border-2 border-dashed flex items-center gap-3 cursor-pointer transition-colors ' +
        (hasError
            ? 'border-red-500 text-red-500'
            : 'border-neutrals-700 ' + (value && value[0] ? 'text-white' : 'text-neutrals-400'));

    return (
        <div className={wrapperClass}>
            <label htmlFor={name} className={boxClass}>
                <img src="/images/icons/other/icon_upload.svg" alt="" className="w-5 h-5 shrink-0" />
                <span className="truncate">
          {value && value[0]
              ? truncate(value[0].name, 30)
              : (labelText ?? 'Foto / Video des Defekts')}
        </span>
            </label>

            <input
                id={name}
                name={name}
                type="file"
                className="hidden"
                onChange={onChange}
                aria-invalid={hasError}
            />

            {hasError && typeof error === 'string' && (
                <p className="mt-1 text-red-500 text-sm">{error}</p>
            )}
        </div>
    );
};

export default UploadField;